import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import { Document, Page } from 'react-pdf';

class CreationDetailsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numPages: null,
            pageNumber: 1,
        };
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    };

    render() {
        console.log(this.props.stateData.rowData?.title, "uuuuuuu")

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Assignment Details</Modal.Title>
                </Modal.Header>
                <>
                    <Modal.Body className="p-4">
                        <Container fluid>
                            <Row className="">
                                <Col as={Col} lg={6} md={12} sm={12}>
                                    <label className="font-weight-bold f-18 mt-2">Title:</label>
                                    <span className="f-18"> {this.props.stateData.rowData?.title}</span>
                                </Col>
                                <Col as={Col} lg={6} md={12} sm={12}>
                                    <label className="font-weight-bold f-18 mt-2">Marks:</label>
                                    <span className="f-18"> {this.props.stateData.rowData?.assignment_marks}</span>
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <Col as={Col} lg={12} md={12} sm={12} className=''>
                                    <p className='font-weight-bold f-18'>Description:</p>
                                    {this.props.stateData.rowData?.description}
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <Col as={Col} lg={12} md={12} sm={12} className=''>
                                    {/* <div className="pdf-container" style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                        <p className='font-weight-bold f-18 text-center mt-3'>Uploaded File:</p>
                                        <Document
                                            file={this.props.stateData.rowData?.file_path}
                                            onLoadSuccess={({ numPages }) => this.setState({ numPages })}
                                        >
                                            {Array.from(new Array(this.state.numPages), (el, index) => (
                                                <Page key={`page_${index + 1}`} pageNumber={index + 1} width={700} />
                                            ))}
                                        </Document>
                                    </div> */}
                                    <div className="pdf-container" style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                        <p className='font-weight-bold f-18 text-center mt-3'>Uploaded File:</p>
                                        {this.props.stateData.rowData.file_path ? (
                                            <Document file={this.props.stateData.rowData.file_path} onLoadSuccess={this.onDocumentLoadSuccess}>
                                                {Array.from(new Array(this.state.numPages || 0), (el, index) => (
                                                    <Page key={`page_${index + 1}`} pageNumber={index + 1} width={700} />
                                                ))}
                                            </Document>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                </>


            </Modal>)
    }
}

export default CreationDetailsModal